import workspaceQuery from '../../queries/sales/PacAllTerminalsQuery.graphql';
import instanceQuery from '../../queries/sales/PacTerminalQuery.graphql';
import mutationQuery from '../../mutations/sales/PacTerminalMutation.graphql';
import fragment from '../../fragments/sales/PacTerminalFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { ALLOW_DELETE, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const PacTerminal: EntityType = {
  type: 'Terminal',
  title: 'Payment Terminal Description',
  formTitle: 'Payment Terminal Description',
  formUrl: '/Sales/PaymentTerminal/Details/',
  workspaceUrl: '/Sales/PaymentTerminal/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'PAYMENT_TERMINALS',
  operations: ALLOW_EDIT | ALLOW_DELETE,
};

export default PacTerminal;
